import styled from 'styled-components';
import { minWidth } from 'helpers/buildMediaQueries';
import { fontVariables } from '@trustedshops/tps-seo-shared-frontend-react-components';

export const FindMoreTitle = styled.p`
  font-size: 20px;
  font-weight: ${fontVariables.FONT_WEIGHT_BOLD};
  text-align: center;
  margin: 36px 0 13px 0;
  ${minWidth('xl', 'margin-top: 50px;')}
`;
